import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import InfoSheetBase from './InfoSheetBase';
import {
  ActorProfileDetailLists
} from '../../../../interfaces/IAuditionInfoSheetDto';
import { IAuditionInfoSheetDto } from '../../../../interfaces/IAuditionInfoSheetDto';

interface IProps extends StateProps, DispatchProps, RouteComponentProps {
  match: any;
}

const NewAuditionInfoSheet: React.FC<IProps> = ({
  match,
  auditionInfoSheet,
  infoSheetOptions,
  createAuditionInfoSheet,
  getInfoSheetOptions,
  updateAuditionInfoSheet
}) => {
  const [infoSheet, setInfoSheet] = useState({});

  useEffect(() => {
    const fetchInfoSheetOptions = async () => {
      await getInfoSheetOptions();
    };

    fetchInfoSheetOptions();
  }, [getInfoSheetOptions]);

  useEffect(() => {
    if (Object.keys(infoSheetOptions).length) {
      setInfoSheet((infoSheet) => ({
        ...infoSheet,
        actorProfileDetailLists: infoSheetOptions
      }));
    }
  }, [infoSheetOptions]);

  useEffect(() => {
    if (Object.keys(auditionInfoSheet).length) {
      setInfoSheet(auditionInfoSheet);
    }
  }, [auditionInfoSheet]);

  const handleSaveAndClose = async () => {
    const { auditionScheduleId } = match.params;
    return await createAuditionInfoSheet(Number(auditionScheduleId));
  };

  if (!Object.keys(infoSheet).length) {
    return (
      <></>
    );
  }

  return (
    <InfoSheetBase
      auditionInfoSheet={infoSheet}
      onChange={(newInfoSheet: any) => setInfoSheet(newInfoSheet)}
      onSaveAndClose={() => handleSaveAndClose()}
    />
  );
};

interface StateProps {
  auditionInfoSheet: any;
  infoSheetOptions: ActorProfileDetailLists;
}

const mapStateToProps = (state: any) => ({
  auditionInfoSheet: state.kiosk.auditionInfoSheet,
  infoSheetOptions: state.kiosk.infoSheetOptions
});

interface DispatchProps {
  createAuditionInfoSheet: (auditionScheduleId: number) => any;
  getInfoSheetOptions: () => void;
  updateAuditionInfoSheet: (auditionInfoSheet: IAuditionInfoSheetDto) => void;
}

const mapDispatchToProps = (dispatch: any) => ({
  createAuditionInfoSheet: dispatch.kiosk.createAuditionInfoSheet,
  getInfoSheetOptions: dispatch.kiosk.getInfoSheetOptions,
  updateAuditionInfoSheet: dispatch.kiosk.updateAuditionInfoSheet
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(NewAuditionInfoSheet));
